module.exports = __webpack_public_path__ + "img/iud.6fee50f8.png";